import React from 'react';
import PropTypes from 'prop-types';
import LoginForm from './LoginForm';

const propTypes = {
	logout: PropTypes.func,
};

const MobileLogin = ({ logout }) => {
	return <LoginForm logout={logout} title="mobileLoginTitle" />;
};

MobileLogin.propTypes = propTypes;

export default MobileLogin;
